import generateRandomInteger from "./generateRandomInteger.util";

const HomeIconsGsap = ({
    getRightSiderefs,
    gsap,
}) => {
    getRightSiderefs.forEach((currentValue, index) => {
        const random_number = generateRandomInteger(-25, -200)
        gsap.timeline({
            scrollTrigger: {
                trigger: currentValue,
                start: "top 60%",
                end: '+=200vh',
                scrub: true,
                toggleActions: "play none none none",
                // markers: true,
                onEnter: () => { },
                onLeaveBack: () => { }
            },
        })
            .fromTo(currentValue, {
                rotation: random_number,
                duration: 20,
            }, {
                rotation: 0,
                duration: 20,
            })
    })
    return () => {
        gsap.killTweensOf(getRightSiderefs);
    };
}

export default HomeIconsGsap